import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Collapse } from "react-bootstrap";
import formatError from "../../services/FormatError";
import swal from "sweetalert";
import incomeStatmentJson from "../../store/IncomeStatementJson";
import {
  addIncomeStatement,
  deleteIncomeStatement,
  getIncomeStatement,
} from "../../services/BusinessService";
import { uploadExcelFile } from "../../services/TemplateManagementService";
import { useTranslation } from "react-i18next";

function validateObject(obj) {
  for (const key in obj) {
    // Check if the value is an object, if so, recursively validate it
    if (typeof obj[key] === "object") {
      if (!validateObject(obj[key])) {
        return false;
      }
    } else {
      // Check if the value is an empty string or a negative integer
      if (obj[key] === "" || parseInt(obj[key]) < 0) {
        return false;
      }
    }
  }
  return true;
}

function validateIncomeStatements(data) {
  for (const statement of data) {
    if (statement.year === "" || parseInt(statement.year) < 0) {
      return false;
    }

    if (!validateObject(statement.incomestatement)) {
      return false;
    }

    for (const assetType in statement.assets) {
      if (!validateObject(statement.assets[assetType])) {
        return false;
      }
    }
  }

  return true;
}

function IncomeStatement() {
  const navigate = useNavigate();

  const { t } = useTranslation();

  const businessId = useLocation()?.state?.businessId;

  const viewMode = useLocation()?.state?.viewMode;

  const [sugg, setSugg] = useState(false);

  const [empty, setEmpty] = useState(false);

  const [yearsData, setYearsData] = useState([]);

  const [triggered, setTriggered] = useState(false);

  const [view, setView] = useState(false);

  const [emptySugg, setEmptySugg] = useState(false);
  const [selectXls, setSelectXls] = useState(null);
  console.log(selectXls);
  const handleUpload = async () => {
    if (!selectXls) {
      swal("Oops", t("hselectfile"), "error", {
        button: t("htry"),
      });
      return;
    }

    try {
      const formData = new FormData();
      formData.append("file", selectXls);

      await uploadExcelFile(formData, businessId);

      swal("Success", t("hfileupload"), "success", {
        button: "OK",
      });
    } catch (error) {
      console.error("Upload failed:", error);
      swal("Oops", t("hfailedupload"), "error", {
        button: t("htry"),
      });
    }
  };

  const handleDownloadSample = () => {
    try {
      const link = document.createElement("a");
      link.href = "/sample.xlsx";
      link.download = "sample.xlsx";
      link.style.display = "none";

      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
      console.error("Download failed:", error);
      swal("Oops", t("hfaileddownload"), "error", {
        button: t("htry"),
      });
    }
  };
  const handleFileChange = (e) => {
    setSelectXls(e.target.files[0]);
  };
  useEffect(() => {
    if (viewMode) {
      setSugg(false);

      setView(true);

      fetchIncomeStatementDetails();
    } else {
      setSugg(true);
    }
  }, [viewMode]);

  const fetchIncomeStatementDetails = () => {
    getIncomeStatement(businessId)
      .then((res) => {
        const response = res.data?.result?.lastfiveyears;

        if (response?.length === 0) {
          setEmpty(true);

          setYearsData([]);

          setTriggered(false);

          setEmptySugg(true);
        } else {
          setYearsData(
            response.map((item, index) => ({
              ...item,
              id: index,
            }))
          );
        }
      })
      .catch((error) => {
        formatError(error.response?.data?.error);
      });
  };

  const onAdd = () => {
    if (!view) {
      setYearsData((prevState) => [
        ...prevState,
        {
          id: prevState?.length,
          ...incomeStatmentJson,
        },
      ]);
    }
  };

  const onChangeInput = (value, id) => {
    if (value?.length <= 4) {
      setYearsData((prevState) =>
        prevState.map((item) => {
          if (item.id === id) {
            return {
              ...item,
              year: parseInt(value),
            };
          }

          return item;
        })
      );
    }
  };

  const ontoggle = (id) => {
    setYearsData((prevState) =>
      prevState.map((item) => {
        if (item.id === id) {
          return {
            ...item,
            open: !item.open,
          };
        }

        return {
          ...item,
          open: false,
        };
      })
    );
  };

  const updateISFields = (
    value,
    id,
    firstkey,
    secondkey,
    thirdkey,
    fourthkey
  ) => {
    if ((/^\d+$/.test(value) && parseInt(value) >= 0) || value === "") {
      setYearsData((prevState) =>
        prevState.map((item) => {
          if (item.id === id) {
            if (fourthkey !== undefined) {
              return {
                ...item,
                [firstkey]: {
                  ...item?.[firstkey],
                  [secondkey]: {
                    ...item?.[firstkey]?.[secondkey],
                    [thirdkey]: {
                      ...item?.[firstkey]?.[secondkey]?.[thirdkey],
                      [fourthkey]: value !== "" ? parseInt(value) : value,
                    },
                  },
                },
              };
            } else if (thirdkey !== undefined) {
              return {
                ...item,
                [firstkey]: {
                  ...item?.[firstkey],
                  [secondkey]: {
                    ...item?.[firstkey]?.[secondkey],
                    [thirdkey]: value !== "" ? parseInt(value) : value,
                  },
                },
              };
            } else {
              return {
                ...item,
                [firstkey]: {
                  ...item?.[firstkey],
                  [secondkey]: value !== "" ? parseInt(value) : value,
                },
              };
            }
          }

          return item;
        })
      );
    }
  };

  const uploadIncomeStatement = (flag) => {
    if (!validateIncomeStatements(yearsData)) {
      setTriggered(true);
    } else {
      setTriggered(false);

      addIncomeStatement(yearsData, businessId, flag)
        .then((res) => {
          setYearsData([]);

          navigate("/business");
        })
        .catch((error) => {
          formatError(error.response?.data?.error);
        });
    }
  };

  const uploadEmptyIncomeStatement = (flag) => {
    // console.log("clicked add inc");
    addIncomeStatement(yearsData, businessId, flag)
      .then((res) => {
        setYearsData([]);

        navigate("/business");
      })
      .catch((error) => {
        formatError(error.response?.data?.error);
      });
  };

  const onDeleteIS = () => {
    swal({
      title: t("hdelete"),
      text: t("hconfirmationDelete"),
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then((willdelete) => {
      if (willdelete) {
        deleteIncomeStatement(businessId)
          .then((res) => {
            swal(t("hsuccessful"), "success");
            navigate(-1);
          })
          .catch((error) => {
            formatError(error.response?.data?.error);
          });
      }
    });
  };

  const onChangeEstablished = (value) => {
    const cond = value === "false" ? false : true;

    setEmpty(cond);

    if (cond) {
      setYearsData([]);
      setTriggered(false);
    }
  };

  return (
    <div className="card">
      <div className="card-header d-sm-flex d-block">
        <div className="d-flex me-auto mb-sm-0">
          <span
            style={{ fontSize: "18px", cursor: "pointer" }}
            className="d-flex justify-content-start align-items-center me-3"
            onClick={() => navigate(-1)}
          >
            <i className="fa fa-arrow-left"></i>
          </span>
          <h3 className="card-title text-primary">
            {t("businessDetailsIncomeStatementButton")}
          </h3>
        </div>
      </div>

      {sugg && (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            background: "#eb8153",
            color: "#fff",
          }}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              flexGrow: "1",
            }}
          >
            {t("hrecentlybusiness")}
          </div>
          <div style={{ flexShrink: "0", marginRight: "8px" }}>
            <i className="fa fa-close" onClick={() => setSugg(false)}></i>
          </div>
        </div>
      )}

      {emptySugg && (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            background: "#eb8153",
            color: "#fff",
          }}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              flexGrow: "1",
            }}
          >
            {t("hestablishedbusiness")}
          </div>
          <div style={{ flexShrink: "0", marginRight: "8px" }}>
            <i className="fa fa-close" onClick={() => setEmptySugg(false)}></i>
          </div>
        </div>
      )}

      <div className="card-body">
        <div className="d-flex justify-content-end align-items-center mb-3 gap-4">
          {!empty && (
            <div className="d-flex gap-3">
              {" "}
              <button
                className="btn btn-primary d-flex align-items-center form-control"
                onClick={handleDownloadSample}
                title="Download sample Excel template"
              >
                <i className="fa fa-download me-2"></i>
                <span className="text-xs"> {t("hdownloadSample")}</span>
              </button>
              <input
                type="file"
                className="form-control mb-3"
                style={{ width: "200px" }}
                accept=".xls,.xlsx"
                onChange={handleFileChange}
              />
              <button
                className="btn btn-primary form-control"
                onClick={handleUpload}
              >
                {t("hupload")}
              </button>
            </div>
          )}
          <div
            className="d-flex justify-content-between align-items-center mb-3"
            style={{ width: "25%" }}
          >
            <select
              className="form-control me-4"
              style={{ border: "1px solid #EEEEEE" }}
              value={empty}
              onChange={(e) => onChangeEstablished(e.target.value)}
            >
              <option value={false}>{t("hPreviouslyEstablised")}</option>
              <option value={true}>{t("hrecentlyEstablished")}</option>
            </select>
            {!empty && (
              <i
                style={{ fontSize: "32px", color: "#eb8153" }}
                className="fa fa-plus-circle"
                onClick={onAdd}
              ></i>
            )}
          </div>
        </div>

        {yearsData?.length > 0 &&
          yearsData.map((item) => {
            const incomestatementDetails = item.incomestatement;

            const currentAssets = item.assets.currentassets;

            const tangibleAssets = item.assets.longtermassets.tangibleassets;

            const equipmentAssets = item.assets.longtermassets.equipmentassets;

            const automotiveAssets =
              item.assets.longtermassets.automotiveassets;

            const officeFurnitureAssets =
              item.assets.longtermassets.officefurnitureassets;

            const hardwareAssets = item.assets.longtermassets.hardwareassets;

            const rentalImprovementsAssets =
              item.assets.longtermassets.rentalimprovementsassets;

            const amountReceivableFromRelatedParties =
              item.assets.longtermassets.amountreceivablefromrelatedparties;

            const currentLiabilities = item.assets.currentliabilities;

            const longTermLiabilities = item.assets.longtermliabilities;

            const equity = item.assets.equity;

            return (
              <div key={`yearIs${item?.id}`} className="mb-4">
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    background: "#2d7af7",
                    color: "#fff",
                    padding: "6px 12px",
                  }}
                >
                  <div style={{ flexGrow: "1" }}>
                    <input
                      style={{
                        height: "100%",
                        width: "100%",
                        background: "transparent",
                        color: "#fff",
                        border: "none",
                      }}
                      type="number"
                      placeholder={t("hyear")}
                      className="income-year-input"
                      maxLength="4"
                      value={item.year}
                      onChange={(e) => onChangeInput(e.target.value, item.id)}
                      disabled={view}
                    />
                  </div>
                  <div style={{ flexShrink: "0", marginRight: "8px" }}>
                    <i
                      className={`fa ${
                        item.open ? "fa-caret-down" : "fa-caret-right"
                      }`}
                      onClick={() => ontoggle(item.id)}
                    ></i>
                  </div>
                </div>

                <Collapse in={item.open} className="">
                  <div
                    style={{ padding: "12px 6px", border: "1px solid #2d7af7" }}
                  >
                    <h4 className="card-title mb-0">
                      {t("businessDetailsIncomeStatementButton")}
                    </h4>

                    <hr />

                    <div className="row">
                      <div className="col-md-12 col-lg-6 col-xl-4">
                        <div
                          className={`form-group ${
                            triggered &&
                            incomestatementDetails?.revenustream1 === ""
                              ? "mb-1"
                              : "mb-3"
                          }`}
                        >
                          <label className="mb-1">
                            <span className="text-danger">*</span>
                            &ensp;
                            <strong>{t("hRevenueStream")}</strong>
                          </label>
                          <input
                            type="number"
                            placeholder={t("hRevenueStream")}
                            className="form-control"
                            value={incomestatementDetails?.revenustream1}
                            onChange={(e) =>
                              updateISFields(
                                e.target.value,
                                item.id,
                                "incomestatement",
                                "revenustream1"
                              )
                            }
                            disabled={view}
                          />
                        </div>
                        {triggered &&
                          incomestatementDetails?.revenustream1 === "" && (
                            <div className="text-danger fs-12 mb-3">
                              {t("hrevenueStreamRequired")}
                            </div>
                          )}
                      </div>

                      <div className="col-md-12 col-lg-6 col-xl-4">
                        <div
                          className={`form-group ${
                            triggered &&
                            incomestatementDetails?.revenustream2 === ""
                              ? "mb-1"
                              : "mb-3"
                          }`}
                        >
                          <label className="mb-1">
                            <span className="text-danger">*</span>
                            &ensp;
                            <strong>{t("hrevenueStream2")}</strong>
                          </label>
                          <input
                            type="number"
                            placeholder="Revenue Stream 2"
                            className="form-control"
                            value={incomestatementDetails?.revenustream2}
                            onChange={(e) =>
                              updateISFields(
                                e.target.value,
                                item.id,
                                "incomestatement",
                                "revenustream2"
                              )
                            }
                            disabled={view}
                          />
                        </div>
                        {triggered &&
                          incomestatementDetails?.revenustream2 === "" && (
                            <div className="text-danger fs-12 mb-3">
                              {t("hrevenueStreamRequired2")}
                            </div>
                          )}
                      </div>

                      <div className="col-md-12 col-lg-6 col-xl-4">
                        <div
                          className={`form-group ${
                            triggered &&
                            incomestatementDetails?.directcosts1 === ""
                              ? "mb-1"
                              : "mb-3"
                          }`}
                        >
                          <label className="mb-1">
                            <span className="text-danger">*</span>
                            &ensp;
                            <strong>{t("hdirectCost")}</strong>
                          </label>
                          <input
                            type="number"
                            placeholder="Direct Costs 1"
                            className="form-control"
                            value={incomestatementDetails?.directcosts1}
                            onChange={(e) =>
                              updateISFields(
                                e.target.value,
                                item.id,
                                "incomestatement",
                                "directcosts1"
                              )
                            }
                            disabled={view}
                          />
                        </div>
                        {triggered &&
                          incomestatementDetails?.directcosts1 === "" && (
                            <div className="text-danger fs-12 mb-3">
                              {t("hdirectCostRequired")}
                            </div>
                          )}
                      </div>

                      <div className="col-md-12 col-lg-6 col-xl-4">
                        <div
                          className={`form-group ${
                            triggered &&
                            incomestatementDetails?.directcosts2 === ""
                              ? "mb-1"
                              : "mb-3"
                          }`}
                        >
                          <label className="mb-1">
                            <span className="text-danger">*</span>
                            &ensp;
                            <strong>{t("hdirectCost1")}</strong>
                          </label>
                          <input
                            type="number"
                            placeholder="Direct Costs 2"
                            className="form-control"
                            value={incomestatementDetails?.directcosts2}
                            onChange={(e) =>
                              updateISFields(
                                e.target.value,
                                item.id,
                                "incomestatement",
                                "directcosts2"
                              )
                            }
                            disabled={view}
                          />
                        </div>
                        {triggered &&
                          incomestatementDetails?.directcosts2 === "" && (
                            <div className="text-danger fs-12 mb-3">
                              {t("hdirectCost1required")}
                            </div>
                          )}
                      </div>

                      <div className="col-md-12 col-lg-6 col-xl-4">
                        <div
                          className={`form-group ${
                            triggered &&
                            incomestatementDetails?.directcosts3 === ""
                              ? "mb-1"
                              : "mb-3"
                          }`}
                        >
                          <label className="mb-1">
                            <span className="text-danger">*</span>
                            &ensp;
                            <strong>{t("hdirectCost2")}</strong>
                          </label>
                          <input
                            type="number"
                            placeholder="Direct Costs 3"
                            className="form-control"
                            value={incomestatementDetails?.directcosts3}
                            onChange={(e) =>
                              updateISFields(
                                e.target.value,
                                item.id,
                                "incomestatement",
                                "directcosts3"
                              )
                            }
                            disabled={view}
                          />
                        </div>
                        {triggered &&
                          incomestatementDetails?.directcosts3 === "" && (
                            <div className="text-danger fs-12 mb-3">
                              {t("hdirectCost2required")}
                            </div>
                          )}
                      </div>

                      <div className="col-md-12 col-lg-6 col-xl-4">
                        <div
                          className={`form-group ${
                            triggered &&
                            incomestatementDetails?.directcosts4 === ""
                              ? "mb-1"
                              : "mb-3"
                          }`}
                        >
                          <label className="mb-1">
                            <span className="text-danger">*</span>
                            &ensp;
                            <strong>{t("hdirectCost3")}</strong>
                          </label>
                          <input
                            type="number"
                            placeholder="Direct Costs 4"
                            className="form-control"
                            value={incomestatementDetails?.directcosts4}
                            onChange={(e) =>
                              updateISFields(
                                e.target.value,
                                item.id,
                                "incomestatement",
                                "directcosts4"
                              )
                            }
                            disabled={view}
                          />
                        </div>
                        {triggered &&
                          incomestatementDetails?.directcosts4 === "" && (
                            <div className="text-danger fs-12 mb-3">
                              {t("hdirectCost3required")}
                            </div>
                          )}
                      </div>

                      <div className="col-md-12 col-lg-6 col-xl-4">
                        <div
                          className={`form-group ${
                            triggered &&
                            incomestatementDetails?.directcosts5 === ""
                              ? "mb-1"
                              : "mb-3"
                          }`}
                        >
                          <label className="mb-1">
                            <span className="text-danger">*</span>
                            &ensp;
                            <strong>{t("hdirectCost4")}</strong>
                          </label>
                          <input
                            type="number"
                            placeholder="Direct Costs 5"
                            className="form-control"
                            value={incomestatementDetails?.directcosts5}
                            onChange={(e) =>
                              updateISFields(
                                e.target.value,
                                item.id,
                                "incomestatement",
                                "directcosts5"
                              )
                            }
                            disabled={view}
                          />
                        </div>
                        {triggered &&
                          incomestatementDetails?.directcosts5 === "" && (
                            <div className="text-danger fs-12 mb-3">
                              {t("hdirectCost4required")}
                            </div>
                          )}
                      </div>

                      <div className="col-md-12 col-lg-6 col-xl-4">
                        <div
                          className={`form-group ${
                            triggered &&
                            incomestatementDetails?.managementandofficesalaries ===
                              ""
                              ? "mb-1"
                              : "mb-3"
                          }`}
                        >
                          <label className="mb-1">
                            <span className="text-danger">*</span>
                            &ensp;
                            <strong>{t("hmanagementOffice")}</strong>
                          </label>
                          <input
                            type="number"
                            placeholder="Management and Office Salaries"
                            className="form-control"
                            value={
                              incomestatementDetails?.managementandofficesalaries
                            }
                            onChange={(e) =>
                              updateISFields(
                                e.target.value,
                                item.id,
                                "incomestatement",
                                "managementandofficesalaries"
                              )
                            }
                            disabled={view}
                          />
                        </div>
                        {triggered &&
                          incomestatementDetails?.managementandofficesalaries ===
                            "" && (
                            <div className="text-danger fs-12 mb-3">
                              {t("hmanagementofficeRequired")}
                            </div>
                          )}
                      </div>

                      <div className="col-md-12 col-lg-6 col-xl-4">
                        <div
                          className={`form-group ${
                            triggered &&
                            incomestatementDetails?.advertisingandmarketing ===
                              ""
                              ? "mb-1"
                              : "mb-3"
                          }`}
                        >
                          <label className="mb-1">
                            <span className="text-danger">*</span>
                            &ensp;
                            <strong>{t("hadvertisingMarketing")}</strong>
                          </label>
                          <input
                            type="number"
                            placeholder="Advertising and Marketing"
                            className="form-control"
                            value={
                              incomestatementDetails?.advertisingandmarketing
                            }
                            onChange={(e) =>
                              updateISFields(
                                e.target.value,
                                item.id,
                                "incomestatement",
                                "advertisingandmarketing"
                              )
                            }
                            disabled={view}
                          />
                        </div>
                        {triggered &&
                          incomestatementDetails?.advertisingandmarketing ===
                            "" && (
                            <div className="text-danger fs-12 mb-3">
                              {t("hadvertisingRequired")}
                            </div>
                          )}
                      </div>

                      <div className="col-md-12 col-lg-6 col-xl-4">
                        <div
                          className={`form-group ${
                            triggered &&
                            incomestatementDetails?.irrecoverabledebts === ""
                              ? "mb-1"
                              : "mb-3"
                          }`}
                        >
                          <label className="mb-1">
                            <span className="text-danger">*</span>
                            &ensp;
                            <strong>{t("hirDebts")}</strong>
                          </label>
                          <input
                            type="number"
                            placeholder="IR Recoverable Debts"
                            className="form-control"
                            value={incomestatementDetails?.irrecoverabledebts}
                            onChange={(e) =>
                              updateISFields(
                                e.target.value,
                                item.id,
                                "incomestatement",
                                "irrecoverabledebts"
                              )
                            }
                            disabled={view}
                          />
                        </div>
                        {triggered &&
                          incomestatementDetails?.irrecoverabledebts === "" && (
                            <div className="text-danger fs-12 mb-3">
                              {t("hirDebtsRequired")}
                            </div>
                          )}
                      </div>

                      <div className="col-md-12 col-lg-6 col-xl-4">
                        <div
                          className={`form-group ${
                            triggered &&
                            incomestatementDetails?.officeandoverheadcosts ===
                              ""
                              ? "mb-1"
                              : "mb-3"
                          }`}
                        >
                          <label className="mb-1">
                            <span className="text-danger">*</span>
                            &ensp;
                            <strong>{t("hofficeOverhead")}</strong>
                          </label>
                          <input
                            type="number"
                            placeholder="Office and Overhead costs"
                            className="form-control"
                            value={
                              incomestatementDetails?.officeandoverheadcosts
                            }
                            onChange={(e) =>
                              updateISFields(
                                e.target.value,
                                item.id,
                                "incomestatement",
                                "officeandoverheadcosts"
                              )
                            }
                            disabled={view}
                          />
                        </div>
                        {triggered &&
                          incomestatementDetails?.officeandoverheadcosts ===
                            "" && (
                            <div className="text-danger fs-12 mb-3">
                              {t("hofficeOverheadRequired")}
                            </div>
                          )}
                      </div>

                      <div className="col-md-12 col-lg-6 col-xl-4">
                        <div
                          className={`form-group ${
                            triggered &&
                            incomestatementDetails?.occupation === ""
                              ? "mb-1"
                              : "mb-3"
                          }`}
                        >
                          <label className="mb-1">
                            <span className="text-danger">*</span>
                            &ensp;
                            <strong>{t("occupationInput")}</strong>
                          </label>
                          <input
                            type="number"
                            placeholder="Occupation"
                            className="form-control"
                            value={incomestatementDetails?.occupation}
                            onChange={(e) =>
                              updateISFields(
                                e.target.value,
                                item.id,
                                "incomestatement",
                                "occupation"
                              )
                            }
                            disabled={view}
                          />
                        </div>
                        {triggered &&
                          incomestatementDetails?.occupation === "" && (
                            <div className="text-danger fs-12 mb-3">
                              {t("api.amgapi.err.151")}
                            </div>
                          )}
                      </div>

                      <div className="col-md-12 col-lg-6 col-xl-4">
                        <div
                          className={`form-group ${
                            triggered &&
                            incomestatementDetails?.professionalfees === ""
                              ? "mb-1"
                              : "mb-3"
                          }`}
                        >
                          <label className="mb-1">
                            <span className="text-danger">*</span>
                            &ensp;
                            <strong>{t("hprofessionalFee")}</strong>
                          </label>
                          <input
                            type="number"
                            placeholder="Professional Fees"
                            className="form-control"
                            value={incomestatementDetails?.professionalfees}
                            onChange={(e) =>
                              updateISFields(
                                e.target.value,
                                item.id,
                                "incomestatement",
                                "professionalfees"
                              )
                            }
                            disabled={view}
                          />
                        </div>
                        {triggered &&
                          incomestatementDetails?.professionalfees === "" && (
                            <div className="text-danger fs-12 mb-3">
                              {t("hprofessionalFeeRequired")}
                            </div>
                          )}
                      </div>

                      <div className="col-md-12 col-lg-6 col-xl-4">
                        <div
                          className={`form-group ${
                            triggered &&
                            incomestatementDetails?.insurance === ""
                              ? "mb-1"
                              : "mb-3"
                          }`}
                        >
                          <label className="mb-1">
                            <span className="text-danger">*</span>
                            &ensp;
                            <strong>{t("hinsurance")}</strong>
                          </label>
                          <input
                            type="number"
                            placeholder="Insurance"
                            className="form-control"
                            value={incomestatementDetails?.insurance}
                            onChange={(e) =>
                              updateISFields(
                                e.target.value,
                                item.id,
                                "incomestatement",
                                "insurance"
                              )
                            }
                            disabled={view}
                          />
                        </div>
                        {triggered &&
                          incomestatementDetails?.insurance === "" && (
                            <div className="text-danger fs-12 mb-3">
                              {t("hinsuranceRequired")}
                            </div>
                          )}
                      </div>

                      <div className="col-md-12 col-lg-6 col-xl-4">
                        <div
                          className={`form-group ${
                            triggered &&
                            incomestatementDetails?.repairandmaintenance === ""
                              ? "mb-1"
                              : "mb-3"
                          }`}
                        >
                          <label className="mb-1">
                            <span className="text-danger">*</span>
                            &ensp;
                            <strong>{t("hrepairMaintenance")}</strong>
                          </label>
                          <input
                            type="number"
                            placeholder="Repair and Maintenance"
                            className="form-control"
                            value={incomestatementDetails?.repairandmaintenance}
                            onChange={(e) =>
                              updateISFields(
                                e.target.value,
                                item.id,
                                "incomestatement",
                                "repairandmaintenance"
                              )
                            }
                            disabled={view}
                          />
                        </div>
                        {triggered &&
                          incomestatementDetails?.repairandmaintenance ===
                            "" && (
                            <div className="text-danger fs-12 mb-3">
                              {t("hrepairMaintenanceRequired")}
                            </div>
                          )}
                      </div>

                      <div className="col-md-12 col-lg-6 col-xl-4">
                        <div
                          className={`form-group ${
                            triggered &&
                            incomestatementDetails?.publicservices === ""
                              ? "mb-1"
                              : "mb-3"
                          }`}
                        >
                          <label className="mb-1">
                            <span className="text-danger">*</span>
                            &ensp;
                            <strong>{t("hpublicService")}</strong>
                          </label>
                          <input
                            type="number"
                            placeholder="Public Services"
                            className="form-control"
                            value={incomestatementDetails?.publicservices}
                            onChange={(e) =>
                              updateISFields(
                                e.target.value,
                                item.id,
                                "incomestatement",
                                "publicservices"
                              )
                            }
                            disabled={view}
                          />
                        </div>
                        {triggered &&
                          incomestatementDetails?.publicservices === "" && (
                            <div className="text-danger fs-12 mb-3">
                              {t("hpublicServiceRequired")}
                            </div>
                          )}
                      </div>

                      <div className="col-md-12 col-lg-6 col-xl-4">
                        <div
                          className={`form-group ${
                            triggered &&
                            incomestatementDetails?.interests === ""
                              ? "mb-1"
                              : "mb-3"
                          }`}
                        >
                          <label className="mb-1">
                            <span className="text-danger">*</span>
                            &ensp;
                            <strong>{t("hinterests")}</strong>
                          </label>
                          <input
                            type="number"
                            placeholder="Interests"
                            className="form-control"
                            value={incomestatementDetails?.interests}
                            onChange={(e) =>
                              updateISFields(
                                e.target.value,
                                item.id,
                                "incomestatement",
                                "interests"
                              )
                            }
                            disabled={view}
                          />
                        </div>
                        {triggered &&
                          incomestatementDetails?.interests === "" && (
                            <div className="text-danger fs-12 mb-3">
                              {t("hinterestsRequired")}
                            </div>
                          )}
                      </div>

                      <div className="col-md-12 col-lg-6 col-xl-4">
                        <div
                          className={`form-group ${
                            triggered &&
                            incomestatementDetails?.depreciation === ""
                              ? "mb-1"
                              : "mb-3"
                          }`}
                        >
                          <label className="mb-1">
                            <span className="text-danger">*</span>
                            &ensp;
                            <strong>{t("hdepreciation")}</strong>
                          </label>
                          <input
                            type="number"
                            placeholder="Depreciation"
                            className="form-control"
                            value={incomestatementDetails?.depreciation}
                            onChange={(e) =>
                              updateISFields(
                                e.target.value,
                                item.id,
                                "incomestatement",
                                "depreciation"
                              )
                            }
                            disabled={view}
                          />
                        </div>
                        {triggered &&
                          incomestatementDetails?.depreciation === "" && (
                            <div className="text-danger fs-12 mb-3">
                              {t("hdepreciatioRequired")}
                            </div>
                          )}
                      </div>

                      <div className="col-md-12 col-lg-6 col-xl-4">
                        <div
                          className={`form-group ${
                            triggered &&
                            incomestatementDetails?.nonoperatingprofit === ""
                              ? "mb-1"
                              : "mb-3"
                          }`}
                        >
                          <label className="mb-1">
                            <span className="text-danger">*</span>
                            &ensp;
                            <strong>{t("hnonOpreationProfit")}</strong>
                          </label>
                          <input
                            type="number"
                            placeholder="Non Operating Profit"
                            className="form-control"
                            value={incomestatementDetails?.nonoperatingprofit}
                            onChange={(e) =>
                              updateISFields(
                                e.target.value,
                                item.id,
                                "incomestatement",
                                "nonoperatingprofit"
                              )
                            }
                            disabled={view}
                          />
                        </div>
                        {triggered &&
                          incomestatementDetails?.nonoperatingprofit === "" && (
                            <div className="text-danger fs-12 mb-3">
                              {t("hnooperattingrequired")}
                            </div>
                          )}
                      </div>

                      <div className="col-md-12 col-lg-6 col-xl-4">
                        <div
                          className={`form-group ${
                            triggered &&
                            incomestatementDetails?.nonoperatingexpenses === ""
                              ? "mb-1"
                              : "mb-3"
                          }`}
                        >
                          <label className="mb-1">
                            <span className="text-danger">*</span>
                            &ensp;
                            <strong>{t("hopreatingExpense")}</strong>
                          </label>
                          <input
                            type="number"
                            placeholder="Non Operating Expenses"
                            className="form-control"
                            value={incomestatementDetails?.nonoperatingexpenses}
                            onChange={(e) =>
                              updateISFields(
                                e.target.value,
                                item.id,
                                "incomestatement",
                                "nonoperatingexpenses"
                              )
                            }
                            disabled={view}
                          />
                        </div>
                        {triggered &&
                          incomestatementDetails?.nonoperatingexpenses ===
                            "" && (
                            <div className="text-danger fs-12 mb-3">
                              {t("hoperatingExpenseRequired")}
                            </div>
                          )}
                      </div>

                      <div className="col-md-12 col-lg-6 col-xl-4">
                        <div
                          className={`form-group ${
                            triggered && incomestatementDetails?.taxes === ""
                              ? "mb-1"
                              : "mb-3"
                          }`}
                        >
                          <label className="mb-1">
                            <span className="text-danger">*</span>
                            &ensp;
                            <strong>{t("htaxes")}</strong>
                          </label>
                          <input
                            type="number"
                            placeholder="Taxes"
                            className="form-control"
                            value={incomestatementDetails?.taxes}
                            onChange={(e) =>
                              updateISFields(
                                e.target.value,
                                item.id,
                                "incomestatement",
                                "taxes"
                              )
                            }
                            disabled={view}
                          />
                        </div>
                        {triggered && incomestatementDetails?.taxes === "" && (
                          <div className="text-danger fs-12 mb-3">
                            {t("htaxesRequired")}
                          </div>
                        )}
                      </div>
                    </div>

                    <hr />

                    <h3 className="card-title mb-0 text-primary">
                      {t("hassets")}
                    </h3>

                    <hr />

                    <div style={{ padding: "4px 12px" }}>
                      <h4 className="card-title mb-0">{t("hcurrentAssets")}</h4>

                      <hr />

                      <div className="row">
                        <div className="col-md-12 col-lg-6 col-xl-4">
                          <div
                            className={`form-group ${
                              triggered && currentAssets?.cash === ""
                                ? "mb-1"
                                : "mb-3"
                            }`}
                          >
                            <label className="mb-1">
                              <span className="text-danger">*</span>
                              &ensp;
                              <strong>{t("hcash")}</strong>
                            </label>
                            <input
                              type="number"
                              placeholder="Cash"
                              className="form-control"
                              value={currentAssets?.cash}
                              onChange={(e) =>
                                updateISFields(
                                  e.target.value,
                                  item.id,
                                  "assets",
                                  "currentassets",
                                  "cash"
                                )
                              }
                              disabled={view}
                            />
                          </div>
                          {triggered && currentAssets?.cash === "" && (
                            <div className="text-danger fs-12 mb-3">
                              {t("hcashrequired")}
                            </div>
                          )}
                        </div>

                        <div className="col-md-12 col-lg-6 col-xl-4">
                          <div
                            className={`form-group ${
                              triggered && currentAssets?.accounts === ""
                                ? "mb-1"
                                : "mb-3"
                            }`}
                          >
                            <label className="mb-1">
                              <span className="text-danger">*</span>
                              &ensp;
                              <strong>{t("haccounts")}</strong>
                            </label>
                            <input
                              type="number"
                              placeholder="Accounts"
                              className="form-control"
                              value={currentAssets?.accounts}
                              onChange={(e) =>
                                updateISFields(
                                  e.target.value,
                                  item.id,
                                  "assets",
                                  "currentassets",
                                  "accounts"
                                )
                              }
                              disabled={view}
                            />
                          </div>
                          {triggered && currentAssets?.accounts === "" && (
                            <div className="text-danger fs-12 mb-3">
                              {t("haccountrequired")}
                            </div>
                          )}
                        </div>

                        <div className="col-md-12 col-lg-6 col-xl-4">
                          <div
                            className={`form-group ${
                              triggered && currentAssets?.stocks === ""
                                ? "mb-1"
                                : "mb-3"
                            }`}
                          >
                            <label className="mb-1">
                              <span className="text-danger">*</span>
                              &ensp;
                              <strong>{t("hstock")}</strong>
                            </label>
                            <input
                              type="number"
                              placeholder="Stocks"
                              className="form-control"
                              value={currentAssets?.stocks}
                              onChange={(e) =>
                                updateISFields(
                                  e.target.value,
                                  item.id,
                                  "assets",
                                  "currentassets",
                                  "stocks"
                                )
                              }
                              disabled={view}
                            />
                          </div>
                          {triggered && currentAssets?.stocks === "" && (
                            <div className="text-danger fs-12 mb-3">
                              {t("hstockrequired")}
                            </div>
                          )}
                        </div>

                        <div className="col-md-12 col-lg-6 col-xl-4">
                          <div
                            className={`form-group ${
                              triggered &&
                              currentAssets?.chargespaidinadvance === ""
                                ? "mb-1"
                                : "mb-3"
                            }`}
                          >
                            <label className="mb-1">
                              <span className="text-danger">*</span>
                              &ensp;
                              <strong>{t("hchargePaid")}</strong>
                            </label>
                            <input
                              type="number"
                              placeholder="Charges Paid In Advance"
                              className="form-control"
                              value={currentAssets?.chargespaidinadvance}
                              onChange={(e) =>
                                updateISFields(
                                  e.target.value,
                                  item.id,
                                  "assets",
                                  "currentassets",
                                  "chargespaidinadvance"
                                )
                              }
                              disabled={view}
                            />
                          </div>
                          {triggered &&
                            currentAssets?.chargespaidinadvance === "" && (
                              <div className="text-danger fs-12 mb-3">
                                {t("hchargePaidRequired")}
                              </div>
                            )}
                        </div>

                        <div className="col-md-12 col-lg-6 col-xl-4">
                          <div
                            className={`form-group ${
                              triggered &&
                              currentAssets?.shortterminvestments === ""
                                ? "mb-1"
                                : "mb-3"
                            }`}
                          >
                            <label className="mb-1">
                              <span className="text-danger">*</span>
                              &ensp;
                              <strong>{t("hshortTermInves")}</strong>
                            </label>
                            <input
                              type="number"
                              placeholder="Short Term Investments"
                              className="form-control"
                              value={currentAssets?.shortterminvestments}
                              onChange={(e) =>
                                updateISFields(
                                  e.target.value,
                                  item.id,
                                  "assets",
                                  "currentassets",
                                  "shortterminvestments"
                                )
                              }
                              disabled={view}
                            />
                          </div>
                          {triggered &&
                            currentAssets?.shortterminvestments === "" && (
                              <div className="text-danger fs-12 mb-3">
                                {t("hshortTermInvesRequired")}
                              </div>
                            )}
                        </div>

                        <div className="col-md-12 col-lg-6 col-xl-4">
                          <div
                            className={`form-group ${
                              triggered &&
                              currentAssets?.taxestoberecovered === ""
                                ? "mb-1"
                                : "mb-3"
                            }`}
                          >
                            <label className="mb-1">
                              <span className="text-danger">*</span>
                              &ensp;
                              <strong>{t("htaxesRecovered")}</strong>
                            </label>
                            <input
                              type="number"
                              placeholder="Taxes to be Recovered"
                              className="form-control"
                              value={currentAssets?.taxestoberecovered}
                              onChange={(e) =>
                                updateISFields(
                                  e.target.value,
                                  item.id,
                                  "assets",
                                  "currentassets",
                                  "taxestoberecovered"
                                )
                              }
                              disabled={view}
                            />
                          </div>
                          {triggered &&
                            currentAssets?.taxestoberecovered === "" && (
                              <div className="text-danger fs-12 mb-3">
                                {t("htaxesRecvoveredRequired")}
                              </div>
                            )}
                        </div>

                        <div className="col-md-12 col-lg-6 col-xl-4">
                          <div
                            className={`form-group ${
                              triggered && currentAssets?.others === ""
                                ? "mb-1"
                                : "mb-3"
                            }`}
                          >
                            <label className="mb-1">
                              <span className="text-danger">*</span>
                              &ensp;
                              <strong>{t("hother")}</strong>
                            </label>
                            <input
                              type="number"
                              placeholder="Others"
                              className="form-control"
                              value={currentAssets?.others}
                              onChange={(e) =>
                                updateISFields(
                                  e.target.value,
                                  item.id,
                                  "assets",
                                  "currentassets",
                                  "others"
                                )
                              }
                              disabled={view}
                            />
                          </div>
                          {triggered && currentAssets?.others === "" && (
                            <div className="text-danger fs-12 mb-3">
                              {t("hotherRequired")}
                            </div>
                          )}
                        </div>
                      </div>

                      <hr />

                      <h3 className="card-title mb-0 text-primary">
                        {t("hlongassets")}
                      </h3>

                      <hr />

                      <div style={{ padding: "4px 12px" }}>
                        <h4 className="card-title mb-0">
                          {t("htangibleassets")}
                        </h4>

                        <hr />

                        <div className="row">
                          <div className="col-md-12 col-lg-6 col-xl-4">
                            <div
                              className={`form-group ${
                                triggered && tangibleAssets?.ground === ""
                                  ? "mb-1"
                                  : "mb-3"
                              }`}
                            >
                              <label className="mb-1">
                                <span className="text-danger">*</span>
                                &ensp;
                                <strong>{t("hground")}</strong>
                              </label>
                              <input
                                type="number"
                                placeholder="Ground"
                                className="form-control"
                                value={tangibleAssets?.ground}
                                onChange={(e) =>
                                  updateISFields(
                                    e.target.value,
                                    item.id,
                                    "assets",
                                    "longtermassets",
                                    "tangibleassets",
                                    "ground"
                                  )
                                }
                                disabled={view}
                              />
                            </div>
                            {triggered && tangibleAssets?.ground === "" && (
                              <div className="text-danger fs-12 mb-3">
                                {t("hgroundrequired")}
                              </div>
                            )}
                          </div>

                          <div className="col-md-12 col-lg-6 col-xl-4">
                            <div
                              className={`form-group ${
                                triggered && tangibleAssets?.buildings === ""
                                  ? "mb-1"
                                  : "mb-3"
                              }`}
                            >
                              <label className="mb-1">
                                <span className="text-danger">*</span>
                                &ensp;
                                <strong>{t("hbuilding")}</strong>
                              </label>
                              <input
                                type="number"
                                placeholder="Buildings"
                                className="form-control"
                                value={tangibleAssets?.buildings}
                                onChange={(e) =>
                                  updateISFields(
                                    e.target.value,
                                    item.id,
                                    "assets",
                                    "longtermassets",
                                    "tangibleassets",
                                    "buildings"
                                  )
                                }
                                disabled={view}
                              />
                            </div>
                            {triggered && tangibleAssets?.buildings === "" && (
                              <div className="text-danger fs-12 mb-3">
                                {t("hbuildingrequired")}
                              </div>
                            )}
                          </div>

                          <div className="col-md-12 col-lg-6 col-xl-4">
                            <div
                              className={`form-group ${
                                triggered &&
                                tangibleAssets?.acquisitioncost === ""
                                  ? "mb-1"
                                  : "mb-3"
                              }`}
                            >
                              <label className="mb-1">
                                <span className="text-danger">*</span>
                                &ensp;
                                <strong>{t("hacquisitioncost")}</strong>
                              </label>
                              <input
                                type="number"
                                placeholder="Acquisition Cost"
                                className="form-control"
                                value={tangibleAssets?.acquisitioncost}
                                onChange={(e) =>
                                  updateISFields(
                                    e.target.value,
                                    item.id,
                                    "assets",
                                    "longtermassets",
                                    "tangibleassets",
                                    "acquisitioncost"
                                  )
                                }
                                disabled={view}
                              />
                            </div>
                            {triggered &&
                              tangibleAssets?.acquisitioncost === "" && (
                                <div className="text-danger fs-12 mb-3">
                                  {t("hacquisitioncostrequired")}
                                </div>
                              )}
                          </div>

                          <div className="col-md-12 col-lg-6 col-xl-4">
                            <div
                              className={`form-group ${
                                triggered &&
                                tangibleAssets?.accumulateddepreciation === ""
                                  ? "mb-1"
                                  : "mb-3"
                              }`}
                            >
                              <label className="mb-1">
                                <span className="text-danger">*</span>
                                &ensp;
                                <strong>{t("haccumulated")}</strong>
                              </label>
                              <input
                                type="number"
                                placeholder="Accumulated Depreciation"
                                className="form-control"
                                value={tangibleAssets?.accumulateddepreciation}
                                onChange={(e) =>
                                  updateISFields(
                                    e.target.value,
                                    item.id,
                                    "assets",
                                    "longtermassets",
                                    "tangibleassets",
                                    "accumulateddepreciation"
                                  )
                                }
                                disabled={view}
                              />
                            </div>
                            {triggered &&
                              tangibleAssets?.accumulateddepreciation ===
                                "" && (
                                <div className="text-danger fs-12 mb-3">
                                  {t("haccumulatedrequired")}
                                </div>
                              )}
                          </div>
                        </div>

                        <hr />

                        <h4 className="card-title mb-0">
                          {t("hequipmentassets")}
                        </h4>

                        <hr />

                        <div className="row">
                          <div className="col-md-12 col-lg-6 col-xl-4">
                            <div
                              className={`form-group ${
                                triggered &&
                                equipmentAssets?.acquisitioncost === ""
                                  ? "mb-1"
                                  : "mb-3"
                              }`}
                            >
                              <label className="mb-1">
                                <span className="text-danger">*</span>
                                &ensp;
                                <strong>{t("hacquisitioncost")}</strong>
                              </label>
                              <input
                                type="number"
                                placeholder="Acquisition Cost"
                                className="form-control"
                                value={equipmentAssets?.acquisitioncost}
                                onChange={(e) =>
                                  updateISFields(
                                    e.target.value,
                                    item.id,
                                    "assets",
                                    "longtermassets",
                                    "equipmentassets",
                                    "acquisitioncost"
                                  )
                                }
                                disabled={view}
                              />
                            </div>
                            {triggered &&
                              equipmentAssets?.acquisitioncost === "" && (
                                <div className="text-danger fs-12 mb-3">
                                  {t("hacquisitioncostrequired")}
                                </div>
                              )}
                          </div>

                          <div className="col-md-12 col-lg-6 col-xl-4">
                            <div
                              className={`form-group ${
                                triggered &&
                                equipmentAssets?.accumlateddepreciation === ""
                                  ? "mb-1"
                                  : "mb-3"
                              }`}
                            >
                              <label className="mb-1">
                                <span className="text-danger">*</span>
                                &ensp;
                                <strong>{t("haccumulated")}</strong>
                              </label>
                              <input
                                type="number"
                                placeholder="Accumlated Depreciation"
                                className="form-control"
                                value={equipmentAssets?.accumlateddepreciation}
                                onChange={(e) =>
                                  updateISFields(
                                    e.target.value,
                                    item.id,
                                    "assets",
                                    "longtermassets",
                                    "equipmentassets",
                                    "accumlateddepreciation"
                                  )
                                }
                                disabled={view}
                              />
                            </div>
                            {triggered &&
                              equipmentAssets?.accumlateddepreciation ===
                                "" && (
                                <div className="text-danger fs-12 mb-3">
                                  {t("haccumulatedrequired")}
                                </div>
                              )}
                          </div>
                        </div>

                        <hr />

                        <h4 className="card-title mb-0">
                          {t("hautomativeassets")}
                        </h4>

                        <hr />

                        <div className="row">
                          <div className="col-md-12 col-lg-6 col-xl-4">
                            <div
                              className={`form-group ${
                                triggered &&
                                automotiveAssets?.acquisitioncost === ""
                                  ? "mb-1"
                                  : "mb-3"
                              }`}
                            >
                              <label className="mb-1">
                                <span className="text-danger">*</span>
                                &ensp;
                                <strong>{t("hacquisitioncost")}</strong>
                              </label>
                              <input
                                type="number"
                                placeholder="Acquisition Cost"
                                className="form-control"
                                value={automotiveAssets?.acquisitioncost}
                                onChange={(e) =>
                                  updateISFields(
                                    e.target.value,
                                    item.id,
                                    "assets",
                                    "longtermassets",
                                    "automotiveassets",
                                    "acquisitioncost"
                                  )
                                }
                                disabled={view}
                              />
                            </div>
                            {triggered &&
                              automotiveAssets?.acquisitioncost === "" && (
                                <div className="text-danger fs-12 mb-3">
                                  {t("hacquisitioncostrequired")}
                                </div>
                              )}
                          </div>

                          <div className="col-md-12 col-lg-6 col-xl-4">
                            <div
                              className={`form-group ${
                                triggered &&
                                automotiveAssets?.accumlateddepreciation === ""
                                  ? "mb-1"
                                  : "mb-3"
                              }`}
                            >
                              <label className="mb-1">
                                <span className="text-danger">*</span>
                                &ensp;
                                <strong>{t("haccumulated")}</strong>
                              </label>
                              <input
                                type="number"
                                placeholder="Accumlated Depreciation"
                                className="form-control"
                                value={automotiveAssets?.accumlateddepreciation}
                                onChange={(e) =>
                                  updateISFields(
                                    e.target.value,
                                    item.id,
                                    "assets",
                                    "longtermassets",
                                    "automotiveassets",
                                    "accumlateddepreciation"
                                  )
                                }
                                disabled={view}
                              />
                            </div>
                            {triggered &&
                              automotiveAssets?.accumlateddepreciation ===
                                "" && (
                                <div className="text-danger fs-12 mb-3">
                                  {t("haccumulatedrequired")}
                                </div>
                              )}
                          </div>
                        </div>

                        <hr />

                        <h4 className="card-title mb-0">
                          {t("hofficeFurniture")}
                        </h4>

                        <hr />

                        <div className="row">
                          <div className="col-md-12 col-lg-6 col-xl-4">
                            <div
                              className={`form-group ${
                                triggered &&
                                officeFurnitureAssets?.acquisitioncost === ""
                                  ? "mb-1"
                                  : "mb-3"
                              }`}
                            >
                              <label className="mb-1">
                                <span className="text-danger">*</span>
                                &ensp;
                                <strong>{t("hacquisitioncost")}</strong>
                              </label>
                              <input
                                type="number"
                                placeholder="Acquisition Cost"
                                className="form-control"
                                value={officeFurnitureAssets?.acquisitioncost}
                                onChange={(e) =>
                                  updateISFields(
                                    e.target.value,
                                    item.id,
                                    "assets",
                                    "longtermassets",
                                    "officefurnitureassets",
                                    "acquisitioncost"
                                  )
                                }
                                disabled={view}
                              />
                            </div>
                            {triggered &&
                              officeFurnitureAssets?.acquisitioncost === "" && (
                                <div className="text-danger fs-12 mb-3">
                                  {t("hacquisitioncostrequired")}
                                </div>
                              )}
                          </div>

                          <div className="col-md-12 col-lg-6 col-xl-4">
                            <div
                              className={`form-group ${
                                triggered &&
                                officeFurnitureAssets?.accumlateddepreciation ===
                                  ""
                                  ? "mb-1"
                                  : "mb-3"
                              }`}
                            >
                              <label className="mb-1">
                                <span className="text-danger">*</span>
                                &ensp;
                                <strong>{t("haccumulated")}</strong>
                              </label>
                              <input
                                type="number"
                                placeholder="Accumlated Depreciation"
                                className="form-control"
                                value={
                                  officeFurnitureAssets?.accumlateddepreciation
                                }
                                onChange={(e) =>
                                  updateISFields(
                                    e.target.value,
                                    item.id,
                                    "assets",
                                    "longtermassets",
                                    "officefurnitureassets",
                                    "accumlateddepreciation"
                                  )
                                }
                                disabled={view}
                              />
                            </div>
                            {triggered &&
                              officeFurnitureAssets?.accumlateddepreciation ===
                                "" && (
                                <div className="text-danger fs-12 mb-3">
                                  {t("haccumulatedrequired")}
                                </div>
                              )}
                          </div>
                        </div>

                        <hr />

                        <h4 className="card-title mb-0">
                          {t("hardwareassets")}
                        </h4>

                        <hr />

                        <div className="row">
                          <div className="col-md-12 col-lg-6 col-xl-4">
                            <div
                              className={`form-group ${
                                triggered &&
                                hardwareAssets?.acquisitioncost === ""
                                  ? "mb-1"
                                  : "mb-3"
                              }`}
                            >
                              <label className="mb-1">
                                <span className="text-danger">*</span>
                                &ensp;
                                <strong>{t("hacquisitioncost")}</strong>
                              </label>
                              <input
                                type="number"
                                placeholder="Acquisition Cost"
                                className="form-control"
                                value={hardwareAssets?.acquisitioncost}
                                onChange={(e) =>
                                  updateISFields(
                                    e.target.value,
                                    item.id,
                                    "assets",
                                    "longtermassets",
                                    "hardwareassets",
                                    "acquisitioncost"
                                  )
                                }
                                disabled={view}
                              />
                            </div>
                            {triggered &&
                              hardwareAssets?.acquisitioncost === "" && (
                                <div className="text-danger fs-12 mb-3">
                                  {t("hacquisitioncostrequired")}
                                </div>
                              )}
                          </div>

                          <div className="col-md-12 col-lg-6 col-xl-4">
                            <div
                              className={`form-group ${
                                triggered &&
                                hardwareAssets?.accumlateddepreciation === ""
                                  ? "mb-1"
                                  : "mb-3"
                              }`}
                            >
                              <label className="mb-1">
                                <span className="text-danger">*</span>
                                &ensp;
                                <strong>{t("haccumulated")}</strong>
                              </label>
                              <input
                                type="number"
                                placeholder="Accumlated Depreciation"
                                className="form-control"
                                value={hardwareAssets?.accumlateddepreciation}
                                onChange={(e) =>
                                  updateISFields(
                                    e.target.value,
                                    item.id,
                                    "assets",
                                    "longtermassets",
                                    "hardwareassets",
                                    "accumlateddepreciation"
                                  )
                                }
                                disabled={view}
                              />
                            </div>
                            {triggered &&
                              hardwareAssets?.accumlateddepreciation === "" && (
                                <div className="text-danger fs-12 mb-3">
                                  {t("haccumulatedrequired")}
                                </div>
                              )}
                          </div>
                        </div>

                        <hr />

                        <h4 className="card-title mb-0">
                          {t("hrentalImprovements")}
                        </h4>

                        <hr />

                        <div className="row">
                          <div className="col-md-12 col-lg-6 col-xl-4">
                            <div
                              className={`form-group ${
                                triggered &&
                                rentalImprovementsAssets?.acquisitioncost === ""
                                  ? "mb-1"
                                  : "mb-3"
                              }`}
                            >
                              <label className="mb-1">
                                <span className="text-danger">*</span>
                                &ensp;
                                <strong>{t("hacquisitioncost")}</strong>
                              </label>
                              <input
                                type="number"
                                placeholder="Acquisition Cost"
                                className="form-control"
                                value={
                                  rentalImprovementsAssets?.acquisitioncost
                                }
                                onChange={(e) =>
                                  updateISFields(
                                    e.target.value,
                                    item.id,
                                    "assets",
                                    "longtermassets",
                                    "rentalimprovementsassets",
                                    "acquisitioncost"
                                  )
                                }
                                disabled={view}
                              />
                            </div>
                            {triggered &&
                              rentalImprovementsAssets?.acquisitioncost ===
                                "" && (
                                <div className="text-danger fs-12 mb-3">
                                  {t("hacquisitioncostrequired")}
                                </div>
                              )}
                          </div>

                          <div className="col-md-12 col-lg-6 col-xl-4">
                            <div
                              className={`form-group ${
                                triggered &&
                                rentalImprovementsAssets?.accumlateddepreciation ===
                                  ""
                                  ? "mb-1"
                                  : "mb-3"
                              }`}
                            >
                              <label className="mb-1">
                                <span className="text-danger">*</span>
                                &ensp;
                                <strong>{t("haccumulated")}</strong>
                              </label>
                              <input
                                type="number"
                                placeholder="Accumlated Depreciation"
                                className="form-control"
                                value={
                                  rentalImprovementsAssets?.accumlateddepreciation
                                }
                                onChange={(e) =>
                                  updateISFields(
                                    e.target.value,
                                    item.id,
                                    "assets",
                                    "longtermassets",
                                    "rentalimprovementsassets",
                                    "accumlateddepreciation"
                                  )
                                }
                                disabled={view}
                              />
                            </div>
                            {triggered &&
                              rentalImprovementsAssets?.accumlateddepreciation ===
                                "" && (
                                <div className="text-danger fs-12 mb-3">
                                  {t("haccumulatedrequired")}
                                </div>
                              )}
                          </div>
                        </div>

                        <hr />

                        <h4 className="card-title mb-0">
                          {t("hamountreceivable")}
                        </h4>

                        <hr />

                        <div className="row">
                          <div className="col-md-12 col-lg-6 col-xl-4">
                            <div
                              className={`form-group ${
                                triggered &&
                                amountReceivableFromRelatedParties?.amountsreceivablefromxyzltd ===
                                  ""
                                  ? "mb-1"
                                  : "mb-3"
                              }`}
                            >
                              <label className="mb-1">
                                <span className="text-danger">*</span>
                                &ensp;
                                <strong>{t("hamountsxyzltd")}</strong>
                              </label>
                              <input
                                type="number"
                                placeholder="Amounts Receivable From xyz ltd"
                                className="form-control"
                                value={
                                  amountReceivableFromRelatedParties?.amountsreceivablefromxyzltd
                                }
                                onChange={(e) =>
                                  updateISFields(
                                    e.target.value,
                                    item.id,
                                    "assets",
                                    "longtermassets",
                                    "amountreceivablefromrelatedparties",
                                    "amountsreceivablefromxyzltd"
                                  )
                                }
                                disabled={view}
                              />
                            </div>
                            {triggered &&
                              amountReceivableFromRelatedParties?.amountsreceivablefromxyzltd ===
                                "" && (
                                <div className="text-danger fs-12 mb-3">
                                  {t("hamountsxyzltdrequired")}
                                </div>
                              )}
                          </div>

                          <div className="col-md-12 col-lg-6 col-xl-4">
                            <div
                              className={`form-group ${
                                triggered &&
                                amountReceivableFromRelatedParties?.amountstobereceivedfromshareholders ===
                                  ""
                                  ? "mb-1"
                                  : "mb-3"
                              }`}
                            >
                              <label className="mb-1">
                                <span className="text-danger">*</span>
                                &ensp;
                                <strong>{t("hamountshareholders")}</strong>
                              </label>
                              <input
                                type="number"
                                placeholder="Amounts to be Received from Shareholders"
                                className="form-control"
                                value={
                                  amountReceivableFromRelatedParties?.amountstobereceivedfromshareholders
                                }
                                onChange={(e) =>
                                  updateISFields(
                                    e.target.value,
                                    item.id,
                                    "assets",
                                    "longtermassets",
                                    "amountreceivablefromrelatedparties",
                                    "amountstobereceivedfromshareholders"
                                  )
                                }
                                disabled={view}
                              />
                            </div>
                            {triggered &&
                              amountReceivableFromRelatedParties?.amountstobereceivedfromshareholders ===
                                "" && (
                                <div className="text-danger fs-12 mb-3">
                                  {t("hamountshareholdersrequired")}
                                </div>
                              )}
                          </div>
                        </div>
                      </div>

                      <hr />

                      <h3 className="card-title mb-0 text-primary">
                        {t("hcurrentliabilities")}
                      </h3>

                      <hr />

                      <div className="row">
                        <div className="col-md-12 col-lg-6 col-xl-4">
                          <div
                            className={`form-group ${
                              triggered &&
                              currentLiabilities?.accountspayable === ""
                                ? "mb-1"
                                : "mb-3"
                            }`}
                          >
                            <label className="mb-1">
                              <span className="text-danger">*</span>
                              &ensp;
                              <strong>{t("haccountPayable")}</strong>
                            </label>
                            <input
                              type="number"
                              placeholder="Accounts Payable"
                              className="form-control"
                              value={currentLiabilities?.accountspayable}
                              onChange={(e) =>
                                updateISFields(
                                  e.target.value,
                                  item.id,
                                  "assets",
                                  "currentliabilities",
                                  "accountspayable"
                                )
                              }
                              disabled={view}
                            />
                          </div>
                          {triggered &&
                            currentLiabilities?.accountspayable === "" && (
                              <div className="text-danger fs-12 mb-3">
                                {t("haccountPayablerequired")}
                              </div>
                            )}
                        </div>

                        <div className="col-md-12 col-lg-6 col-xl-4">
                          <div
                            className={`form-group ${
                              triggered &&
                              currentLiabilities?.chargednotes === ""
                                ? "mb-1"
                                : "mb-3"
                            }`}
                          >
                            <label className="mb-1">
                              <span className="text-danger">*</span>
                              &ensp;
                              <strong>{t("hchargednote")}</strong>
                            </label>
                            <input
                              type="number"
                              placeholder="Charged Notes"
                              className="form-control"
                              value={currentLiabilities?.chargednotes}
                              onChange={(e) =>
                                updateISFields(
                                  e.target.value,
                                  item.id,
                                  "assets",
                                  "currentliabilities",
                                  "chargednotes"
                                )
                              }
                              disabled={view}
                            />
                          </div>
                          {triggered &&
                            currentLiabilities?.chargednotes === "" && (
                              <div className="text-danger fs-12 mb-3">
                                {t("hchargednoterequired")}
                              </div>
                            )}
                        </div>

                        <div className="col-md-12 col-lg-6 col-xl-4">
                          <div
                            className={`form-group ${
                              triggered &&
                              currentLiabilities?.deferredproducts === ""
                                ? "mb-1"
                                : "mb-3"
                            }`}
                          >
                            <label className="mb-1">
                              <span className="text-danger">*</span>
                              &ensp;
                              <strong>{t("hdeferredProduct")}</strong>
                            </label>
                            <input
                              type="number"
                              placeholder="Deferred Products"
                              className="form-control"
                              value={currentLiabilities?.deferredproducts}
                              onChange={(e) =>
                                updateISFields(
                                  e.target.value,
                                  item.id,
                                  "assets",
                                  "currentliabilities",
                                  "deferredproducts"
                                )
                              }
                              disabled={view}
                            />
                          </div>
                          {triggered &&
                            currentLiabilities?.deferredproducts === "" && (
                              <div className="text-danger fs-12 mb-3">
                                {t("hdeferredRequired")}
                              </div>
                            )}
                        </div>

                        <div className="col-md-12 col-lg-6 col-xl-4">
                          <div
                            className={`form-group ${
                              triggered &&
                              currentLiabilities?.customerdeposits === ""
                                ? "mb-1"
                                : "mb-3"
                            }`}
                          >
                            <label className="mb-1">
                              <span className="text-danger">*</span>
                              &ensp;
                              <strong>{t("hcustomerDeposits")}</strong>
                            </label>
                            <input
                              type="number"
                              placeholder="Customer Deposits"
                              className="form-control"
                              value={currentLiabilities?.customerdeposits}
                              onChange={(e) =>
                                updateISFields(
                                  e.target.value,
                                  item.id,
                                  "assets",
                                  "currentliabilities",
                                  "customerdeposits"
                                )
                              }
                              disabled={view}
                            />
                          </div>
                          {triggered &&
                            currentLiabilities?.customerdeposits === "" && (
                              <div className="text-danger fs-12 mb-3">
                                {t("hcustomDepositsrequired")}
                              </div>
                            )}
                        </div>

                        <div className="col-md-12 col-lg-6 col-xl-4">
                          <div
                            className={`form-group ${
                              triggered &&
                              currentLiabilities?.governmentrebatesdue === ""
                                ? "mb-1"
                                : "mb-3"
                            }`}
                          >
                            <label className="mb-1">
                              <span className="text-danger">*</span>
                              &ensp;
                              <strong>{t("hgovernment")}</strong>
                            </label>
                            <input
                              type="number"
                              placeholder="Government Rebates Due"
                              className="form-control"
                              value={currentLiabilities?.governmentrebatesdue}
                              onChange={(e) =>
                                updateISFields(
                                  e.target.value,
                                  item.id,
                                  "assets",
                                  "currentliabilities",
                                  "governmentrebatesdue"
                                )
                              }
                              disabled={view}
                            />
                          </div>
                          {triggered &&
                            currentLiabilities?.governmentrebatesdue === "" && (
                              <div className="text-danger fs-12 mb-3">
                                {t("hgovernmentrequired")}
                              </div>
                            )}
                        </div>

                        <div className="col-md-12 col-lg-6 col-xl-4">
                          <div
                            className={`form-group ${
                              triggered &&
                              currentLiabilities?.currentportionoflongtermdept ===
                                ""
                                ? "mb-1"
                                : "mb-3"
                            }`}
                          >
                            <label className="mb-1">
                              <span className="text-danger">*</span>
                              &ensp;
                              <strong>{t("hcurrentPortion")}</strong>
                            </label>
                            <input
                              type="number"
                              placeholder="Current Portion of Long Term Dept"
                              className="form-control"
                              value={
                                currentLiabilities?.currentportionoflongtermdept
                              }
                              onChange={(e) =>
                                updateISFields(
                                  e.target.value,
                                  item.id,
                                  "assets",
                                  "currentliabilities",
                                  "currentportionoflongtermdept"
                                )
                              }
                              disabled={view}
                            />
                          </div>
                          {triggered &&
                            currentLiabilities?.currentportionoflongtermdept ===
                              "" && (
                              <div className="text-danger fs-12 mb-3">
                                {t("hcurrentPortionrequired")}
                              </div>
                            )}
                        </div>

                        <div className="col-md-12 col-lg-6 col-xl-4">
                          <div
                            className={`form-group ${
                              triggered &&
                              currentLiabilities?.currentportionofcapitalleasecontracts ===
                                ""
                                ? "mb-1"
                                : "mb-3"
                            }`}
                          >
                            <label className="mb-1">
                              <span className="text-danger">*</span>
                              &ensp;
                              <strong>{t("hcurrentportionCapital")}</strong>
                            </label>
                            <input
                              type="number"
                              placeholder="Current Portion of Capital Lease Contracts"
                              className="form-control"
                              value={
                                currentLiabilities?.currentportionofcapitalleasecontracts
                              }
                              onChange={(e) =>
                                updateISFields(
                                  e.target.value,
                                  item.id,
                                  "assets",
                                  "currentliabilities",
                                  "currentportionofcapitalleasecontracts"
                                )
                              }
                              disabled={view}
                            />
                          </div>
                          {triggered &&
                            currentLiabilities?.currentportionofcapitalleasecontracts ===
                              "" && (
                              <div className="text-danger fs-12 mb-3">
                                {t("hcurrentportionCapitalrequired")}
                              </div>
                            )}
                        </div>

                        <div className="col-md-12 col-lg-6 col-xl-4">
                          <div
                            className={`form-group ${
                              triggered && currentLiabilities?.others === ""
                                ? "mb-1"
                                : "mb-3"
                            }`}
                          >
                            <label className="mb-1">
                              <span className="text-danger">*</span>
                              &ensp;
                              <strong>{t("hother")}</strong>
                            </label>
                            <input
                              type="number"
                              placeholder="Others"
                              className="form-control"
                              value={currentLiabilities?.others}
                              onChange={(e) =>
                                updateISFields(
                                  e.target.value,
                                  item.id,
                                  "assets",
                                  "currentliabilities",
                                  "others"
                                )
                              }
                              disabled={view}
                            />
                          </div>
                          {triggered && currentLiabilities?.others === "" && (
                            <div className="text-danger fs-12 mb-3">
                              {t("hotherRequired")}
                            </div>
                          )}
                        </div>
                      </div>

                      <hr />

                      <h3 className="card-title mb-0 text-primary">
                        {t("hlongtermliabilities")}
                      </h3>

                      <hr />

                      <div className="row">
                        <div className="col-md-12 col-lg-6 col-xl-4">
                          <div
                            className={`form-group ${
                              triggered &&
                              longTermLiabilities?.longtermdebt === ""
                                ? "mb-1"
                                : "mb-3"
                            }`}
                          >
                            <label className="mb-1">
                              <span className="text-danger">*</span>
                              &ensp;
                              <strong>{t("hlongtermdebt")}</strong>
                            </label>
                            <input
                              type="number"
                              placeholder="Long Term Debt"
                              className="form-control"
                              value={longTermLiabilities?.longtermdebt}
                              onChange={(e) =>
                                updateISFields(
                                  e.target.value,
                                  item.id,
                                  "assets",
                                  "longtermliabilities",
                                  "longtermdebt"
                                )
                              }
                              disabled={view}
                            />
                          </div>
                          {triggered &&
                            longTermLiabilities?.longtermdebt === "" && (
                              <div className="text-danger fs-12 mb-3">
                                {t("hlongtermdebtrequired")}
                              </div>
                            )}
                        </div>

                        <div className="col-md-12 col-lg-6 col-xl-4">
                          <div
                            className={`form-group ${
                              triggered &&
                              longTermLiabilities?.capitalleases === ""
                                ? "mb-1"
                                : "mb-3"
                            }`}
                          >
                            <label className="mb-1">
                              <span className="text-danger">*</span>
                              &ensp;
                              <strong>{t("hcapitalleases")}</strong>
                            </label>
                            <input
                              type="number"
                              placeholder="Capital Leases"
                              className="form-control"
                              value={longTermLiabilities?.capitalleases}
                              onChange={(e) =>
                                updateISFields(
                                  e.target.value,
                                  item.id,
                                  "assets",
                                  "longtermliabilities",
                                  "capitalleases"
                                )
                              }
                              disabled={view}
                            />
                          </div>
                          {triggered &&
                            longTermLiabilities?.capitalleases === "" && (
                              <div className="text-danger fs-12 mb-3">
                                {t("hcapitalleasesrequired")}
                              </div>
                            )}
                        </div>

                        <div className="col-md-12 col-lg-6 col-xl-4">
                          <div
                            className={`form-group ${
                              triggered &&
                              longTermLiabilities?.amounttobepaidtorelatedparties ===
                                ""
                                ? "mb-1"
                                : "mb-3"
                            }`}
                          >
                            <label className="mb-1">
                              <span className="text-danger">*</span>
                              &ensp;
                              <strong>{t("hamounPaid")}</strong>
                            </label>
                            <input
                              type="number"
                              placeholder="Amount to be Paid to Related Parties"
                              className="form-control"
                              value={
                                longTermLiabilities?.amounttobepaidtorelatedparties
                              }
                              onChange={(e) =>
                                updateISFields(
                                  e.target.value,
                                  item.id,
                                  "assets",
                                  "longtermliabilities",
                                  "amounttobepaidtorelatedparties"
                                )
                              }
                              disabled={view}
                            />
                          </div>
                          {triggered &&
                            longTermLiabilities?.amounttobepaidtorelatedparties ===
                              "" && (
                              <div className="text-danger fs-12 mb-3">
                                {t("hamountPaidrequired")}
                              </div>
                            )}
                        </div>

                        <div className="col-md-12 col-lg-6 col-xl-4">
                          <div
                            className={`form-group ${
                              triggered &&
                              longTermLiabilities?.amountstobepaidtoabcltd ===
                                ""
                                ? "mb-1"
                                : "mb-3"
                            }`}
                          >
                            <label className="mb-1">
                              <span className="text-danger">*</span>
                              &ensp;
                              <strong>{t("hamountsPaid")}</strong>
                            </label>
                            <input
                              type="number"
                              placeholder="Amounts to be Paid to abc ltd"
                              className="form-control"
                              value={
                                longTermLiabilities?.amountstobepaidtoabcltd
                              }
                              onChange={(e) =>
                                updateISFields(
                                  e.target.value,
                                  item.id,
                                  "assets",
                                  "longtermliabilities",
                                  "amountstobepaidtoabcltd"
                                )
                              }
                              disabled={view}
                            />
                          </div>
                          {triggered &&
                            longTermLiabilities?.amountstobepaidtoabcltd ===
                              "" && (
                              <div className="text-danger fs-12 mb-3">
                                {t("hamountsPaidrequired")}
                              </div>
                            )}
                        </div>

                        <div className="col-md-12 col-lg-6 col-xl-4">
                          <div
                            className={`form-group ${
                              triggered &&
                              longTermLiabilities?.amountstobepaidtoshareholders ===
                                ""
                                ? "mb-1"
                                : "mb-3"
                            }`}
                          >
                            <label className="mb-1">
                              <span className="text-danger">*</span>
                              &ensp;
                              <strong>{t("hpaidshareholders")}</strong>
                            </label>
                            <input
                              type="number"
                              placeholder="Amounts to be Paid to Shareholders"
                              className="form-control"
                              value={
                                longTermLiabilities?.amountstobepaidtoshareholders
                              }
                              onChange={(e) =>
                                updateISFields(
                                  e.target.value,
                                  item.id,
                                  "assets",
                                  "longtermliabilities",
                                  "amountstobepaidtoshareholders"
                                )
                              }
                              disabled={view}
                            />
                          </div>
                          {triggered &&
                            longTermLiabilities?.amountstobepaidtoshareholders ===
                              "" && (
                              <div className="text-danger fs-12 mb-3">
                                {t("hpaidshareholdersrequired")}
                              </div>
                            )}
                        </div>

                        <div className="col-md-12 col-lg-6 col-xl-4">
                          <div
                            className={`form-group ${
                              triggered &&
                              longTermLiabilities?.otheramounts === ""
                                ? "mb-1"
                                : "mb-3"
                            }`}
                          >
                            <label className="mb-1">
                              <span className="text-danger">*</span>
                              &ensp;
                              <strong>{t("hotherAmounts")}</strong>
                            </label>
                            <input
                              type="number"
                              placeholder="Other Amounts"
                              className="form-control"
                              value={longTermLiabilities?.otheramounts}
                              onChange={(e) =>
                                updateISFields(
                                  e.target.value,
                                  item.id,
                                  "assets",
                                  "longtermliabilities",
                                  "otheramounts"
                                )
                              }
                              disabled={view}
                            />
                          </div>
                          {triggered &&
                            longTermLiabilities?.otheramounts === "" && (
                              <div className="text-danger fs-12 mb-3">
                                {t("hotherAmountsrequired")}
                              </div>
                            )}
                        </div>
                      </div>

                      <hr />

                      <h3 className="card-title mb-0 text-primary">
                        {t("equity")}
                      </h3>

                      <hr />

                      <div className="row">
                        <div className="col-md-12 col-lg-6 col-xl-4">
                          <div
                            className={`form-group ${
                              triggered && equity?.ordinaryactions === ""
                                ? "mb-1"
                                : "mb-3"
                            }`}
                          >
                            <label className="mb-1">
                              <span className="text-danger">*</span>
                              &ensp;
                              <strong>{t("horinaryaction")}</strong>
                            </label>
                            <input
                              type="number"
                              placeholder="Ordinary Actions"
                              className="form-control"
                              value={equity?.ordinaryactions}
                              onChange={(e) =>
                                updateISFields(
                                  e.target.value,
                                  item.id,
                                  "assets",
                                  "equity",
                                  "ordinaryactions"
                                )
                              }
                              disabled={view}
                            />
                          </div>
                          {triggered && equity?.ordinaryactions === "" && (
                            <div className="text-danger fs-12 mb-3">
                              {t("hordinaryactionrequired")}
                            </div>
                          )}
                        </div>

                        <div className="col-md-12 col-lg-6 col-xl-4">
                          <div
                            className={`form-group ${
                              triggered && equity?.preferredshares === ""
                                ? "mb-1"
                                : "mb-3"
                            }`}
                          >
                            <label className="mb-1">
                              <span className="text-danger">*</span>
                              &ensp;
                              <strong>{t("hpreferredshares")}</strong>
                            </label>
                            <input
                              type="number"
                              placeholder="Preferred Shares"
                              className="form-control"
                              value={equity?.preferredshares}
                              onChange={(e) =>
                                updateISFields(
                                  e.target.value,
                                  item.id,
                                  "assets",
                                  "equity",
                                  "preferredshares"
                                )
                              }
                              disabled={view}
                            />
                          </div>
                          {triggered && equity?.preferredshares === "" && (
                            <div className="text-danger fs-12 mb-3">
                              {t("hpreferedsharesrequired")}
                            </div>
                          )}
                        </div>

                        <div className="col-md-12 col-lg-6 col-xl-4">
                          <div
                            className={`form-group ${
                              triggered && equity?.profitsnotdistributed === ""
                                ? "mb-1"
                                : "mb-3"
                            }`}
                          >
                            <label className="mb-1">
                              <span className="text-danger">*</span>
                              &ensp;
                              <strong>{t("hprofitsnotdistributed")}</strong>
                            </label>
                            <input
                              type="number"
                              placeholder="Profits Not Distributed"
                              className="form-control"
                              value={equity?.profitsnotdistributed}
                              onChange={(e) =>
                                updateISFields(
                                  e.target.value,
                                  item.id,
                                  "assets",
                                  "equity",
                                  "profitsnotdistributed"
                                )
                              }
                              disabled={view}
                            />
                          </div>
                          {triggered &&
                            equity?.profitsnotdistributed === "" && (
                              <div className="text-danger fs-12 mb-3">
                                {t("hprofitsnotdistributedrequired")}
                              </div>
                            )}
                        </div>

                        <div className="col-md-12 col-lg-6 col-xl-4">
                          <div
                            className={`form-group ${
                              triggered &&
                              equity?.openingbalanceofretainedearnings === ""
                                ? "mb-1"
                                : "mb-3"
                            }`}
                          >
                            <label className="mb-1">
                              <span className="text-danger">*</span>
                              &ensp;
                              <strong>{t("hopeningBalance")}</strong>
                            </label>
                            <input
                              type="number"
                              placeholder="Opening Balance of Retained Earnings"
                              className="form-control"
                              value={equity?.openingbalanceofretainedearnings}
                              onChange={(e) =>
                                updateISFields(
                                  e.target.value,
                                  item.id,
                                  "assets",
                                  "equity",
                                  "openingbalanceofretainedearnings"
                                )
                              }
                              disabled={view}
                            />
                          </div>
                          {triggered &&
                            equity?.openingbalanceofretainedearnings === "" && (
                              <div className="text-danger fs-12 mb-3">
                                {t("hopeningBalancerequired")}
                              </div>
                            )}
                        </div>

                        <div className="col-md-12 col-lg-6 col-xl-4">
                          <div
                            className={`form-group ${
                              triggered &&
                              equity?.incomeforthecurrentperiod === ""
                                ? "mb-1"
                                : "mb-3"
                            }`}
                          >
                            <label className="mb-1">
                              <span className="text-danger">*</span>
                              &ensp;
                              <strong>{t("hincomecurrent")}</strong>
                            </label>
                            <input
                              type="number"
                              placeholder="Income for the Current Period"
                              className="form-control"
                              value={equity?.incomeforthecurrentperiod}
                              onChange={(e) =>
                                updateISFields(
                                  e.target.value,
                                  item.id,
                                  "assets",
                                  "equity",
                                  "incomeforthecurrentperiod"
                                )
                              }
                              disabled={view}
                            />
                          </div>
                          {triggered &&
                            equity?.incomeforthecurrentperiod === "" && (
                              <div className="text-danger fs-12 mb-3">
                                {t("hincomecurrentrequired")}
                              </div>
                            )}
                        </div>

                        <div className="col-md-12 col-lg-6 col-xl-4">
                          <div
                            className={`form-group ${
                              triggered && equity?.dividendspaid === ""
                                ? "mb-1"
                                : "mb-3"
                            }`}
                          >
                            <label className="mb-1">
                              <span className="text-danger">*</span>
                              &ensp;
                              <strong>{t("hdividendspaid")}</strong>
                            </label>
                            <input
                              type="number"
                              placeholder="Dividends Paid"
                              className="form-control"
                              value={equity?.dividendspaid}
                              onChange={(e) =>
                                updateISFields(
                                  e.target.value,
                                  item.id,
                                  "assets",
                                  "equity",
                                  "dividendspaid"
                                )
                              }
                              disabled={view}
                            />
                          </div>
                          {triggered && equity?.dividendspaid === "" && (
                            <div className="text-danger fs-12 mb-3">
                              {t("hdividendspaidrequired")}
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </Collapse>
              </div>
            );
          })}

        <div className="row">
          <div className="col-md-12 mb-5">
            <div className="d-flex justify-content-center align-items-center">
              {viewMode && view && (
                <button
                  type="button"
                  style={{ background: "grey", borderColor: "grey" }}
                  className="btn btn-primary me-3"
                  onClick={() => setView(false)}
                >
                  {t("editButton")}
                </button>
              )}
              {viewMode && !view && (
                <button
                  type="button"
                  className="btn btn-primary me-3"
                  onClick={() => uploadIncomeStatement("update")}
                >
                  {t("update")}
                </button>
              )}
              {viewMode && !view && (
                <button
                  type="button"
                  style={{ background: "grey", borderColor: "grey" }}
                  className="btn btn-primary me-3"
                  onClick={() => setView(true)}
                >
                  {t("hview")}
                </button>
              )}
              {viewMode && (
                <button
                  type="button"
                  className="btn btn-danger"
                  onClick={onDeleteIS}
                >
                  {t("delete")}
                </button>
              )}
              {!viewMode && yearsData?.length > 0 && (
                <button
                  type="button"
                  className="btn btn-success"
                  onClick={() => uploadIncomeStatement("add")}
                >
                  {t("globalAddButton")}
                </button>
              )}
              {!viewMode && empty && (
                <button
                  type="button"
                  className="btn btn-success"
                  onClick={() => uploadEmptyIncomeStatement("add")}
                >
                  {t("globalAddButton")}
                </button>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default IncomeStatement;
